<template>
	<article>
		<section class="xbed-sub-title">
			<span>{{title}}</span>
		</section>

		<section class="xbed-breadcrumb">
			<Breadcrumb>
				<BreadcrumbItem>首页</BreadcrumbItem>
				<BreadcrumbItem>订单管理</BreadcrumbItem>
				<BreadcrumbItem>{{title}}</BreadcrumbItem>
			</Breadcrumb>
		</section>

		<section style="min-height: 500px;max-width:1425px">
			<Tabs @on-click="toggleTab">
				<TabPane label="发送短信" name="send">
					<Row>
						<Col span="12">
							<Form :label-width="80" :model="send" :rules="send.rules" ref="sendForm">
								<FormItem label="手机号" prop="phone">
									<Input v-model.trim="send.phone" :maxlength="11"></Input>
								</FormItem>

								<FormItem label="短信内容" prop="content">
									<Input v-model="send.content" type="textarea" :autosize="{minRows: 2,maxRows: 5}"></Input>
								</FormItem>

								<FormItem>
									<Button type="primary" @click="sendSMS" long>发送</Button>
								</FormItem>
							</Form>
						</Col>
					</Row>
				</TabPane>
				<!-- 隐藏标签页 “短信评价”、“短信记录”  modify by lty 2019-10-31 -->
				<!-- <TabPane label="短信记录" name="record">
					<Row>
						<Form :model="record" :rules="record.rules" inline>
							<FormItem label="发送时间" :label-width="80">
								<DatePicker v-model="record.date" type="daterange" style="width: 200px" @on-change="(date)=>{selectedDate(date, 'record')}" :clearable="false"></DatePicker>
							</FormItem>

							<FormItem label="收件人手机号" prop="phone" :label-width="100">
								<Input v-model.trim="record.phone" :maxlength="11"></Input>
							</FormItem>

							<FormItem label="关键字" prop="keyword" label-position="right" :label-width="60">
								<Input v-model="record.keyword" placeholder="请输入查询关键字"></Input>
							</FormItem>

							<FormItem>
								<Button type="primary" @click="search">查询</Button>
							</FormItem>
						</Form>
					</Row>

					<Row>
						<Table :columns="record.columns" :data="record.data"></Table>
					</Row>

					<div style="float: left;margin: 10px;overflow: hidden">
						<Page show-sizer :total="record.total" :current="record.page" @on-change="changePage" @on-page-size-change="changePageSize" placement="top"></Page>
					</div>
				</TabPane>
				<TabPane label="短信评价" name="appraisal">
					<Row>
						<Form :model="appraisal" :rules="appraisal.rules" ref="appraisalForm" inline>
							<FormItem label="呼叫时间" :label-width="80">
								<DatePicker v-model="appraisal.date" type="daterange" style="width: 200px" @on-change="(date)=>{selectedDate(date, 'appraisal')}" :clearable="false"></DatePicker>
							</FormItem>

							<FormItem label="通话状态" style="width: 200px" :label-width="80">
								<Select v-model="appraisal.talkType">
									<Option value="S00">全部</Option>
									<Option :value="0">接听失败</Option>
									<Option :value="1">接听成功</Option>
								</Select>
							</FormItem>

							<FormItem label="评价状态" style="width: 200px" label-position="right" :label-width="80">
								<Select v-model="appraisal.evaluateType">
									<Option value="S00">全部</Option>
									<Option :value="1">未评价</Option>
									<Option :value="3">待评价</Option>
									<Option :value="2">已评价</Option>
								</Select>
							</FormItem>

							<FormItem label="客户号码" label-position="right" prop="phone" :label-width="80">
								<Input v-model="appraisal.phone" placeholder="请输入客户号码"></Input>
							</FormItem>

							<FormItem label="客服电话" label-position="right" :label-width="80">
								<Input v-model="appraisal.seatNo" placeholder="请输入客服电话"></Input>
							</FormItem>

							<FormItem label="评价内容" label-position="right" prop="content" :label-width="80">
								<Input v-model="appraisal.content" placeholder="请输入查询关键字"></Input>
							</FormItem>

							<FormItem>
								<Button type="primary" @click="search">查询</Button>
							</FormItem>
							<FormItem>
								<Button type="primary" @click="exportAppraisal" :loading="exportBtn">导出列表</Button>
							</FormItem>
						</Form>
					</Row>

					<Row>
						<Table :columns="appraisal.columns" :data="appraisal.data"></Table>
					</Row>

					<div style="float: left;margin: 10px;overflow: hidden">
						<Page show-sizer :total="appraisal.total" :current="appraisal.page" @on-change="changePage" @on-page-size-change="changePageSize" placement="top"></Page>
					</div>
				</TabPane> -->
				<TabPane label="【OMS】短信记录" name="omsRecord">
					<Form @submit.native.prevent="preventSubmit" :model="omsRecord" :rules="omsRecord.rules" inline>
						<FormItem label="发送时间" :label-width="80">
							<DatePicker v-model="omsRecord.date" type="daterange" style="width: 200px" clearable class="date-time"></DatePicker>
						</FormItem>
						<FormItem label="收件人手机号" prop="phone" :label-width="100">
							<Input v-model.trim="omsRecord.phone" :maxlength="11"></Input>
						</FormItem>
						<FormItem label="关键字" prop="keyword" label-position="right" :label-width="80">
							<Input v-model="omsRecord.keyword" placeholder="请输入查询关键字" style="width:250px;"></Input>
						</FormItem>
						<FormItem label="订单号" prop="orderNo" :label-width="80">
							<Input v-model="omsRecord.orderNo" placeholder="" style="width:250px;"></Input>
						</FormItem>
						<br>
						<FormItem label="发送通道" prop="sendWay" :label-width="80" style="width:250px;">
							<Select v-model="omsRecord.sendWay">
								<Option value="S00">全部</Option>
								<Option :value="1">阿里</Option>
								<Option :value="2">至臻</Option>
							</Select>
						</FormItem>
						<FormItem label="发送状态" prop="sendStatus" :label-width="80" style="width:250px;">
							<Select v-model="omsRecord.sendStatus">
								<Option value="S00">全部</Option>
								<Option :value="1">发送中</Option>
								<Option :value="2">发送成功</Option>
								<Option :value="3">发送失败</Option>
							</Select>
						</FormItem>
						<FormItem label="发送方式" prop="sendBy" :label-width="80" style="width:250px;">
							<Select v-model="omsRecord.sendBy">
								<Option value="S00">全部</Option>
								<Option :value="1">系统自动发送</Option>
								<Option :value="2">人工手动发送</Option>
							</Select>
						</FormItem>
						<FormItem>
							<Button type="primary" @click="search">查询</Button>
						</FormItem>
					</Form>
					<Content>
						<Table :columns="omsRecord.columns" :data="omsRecord.data" :loading='omsSmsLoading'></Table>
						<div style="float: left;margin: 10px;overflow: hidden">
							<Page show-sizer :total="omsRecord.total" :current="omsRecord.page" @on-change="changePage" @on-page-size-change="changePageSize" placement="top"></Page>
						</div>
					</Content>
				</TabPane>
			</Tabs>
		</section>
	</article>
</template>

<script>
import Moment from "moment";
import Utils from "../../utils";
import {phoneRegular} from "../../utils/regular"
import API from "../../api";
import Config from "../../config"
import {STORE_KEY} from "../../constants"

export default {
	created() {
		this.token = Utils.findFromLocalStorage( "vue-token" );
		this.username = Utils.findFromLocalStorage( "vue-username" );
		this.env = Utils.findFromLocalStorage( "env", "dev" );
		this.headerENV = Utils.aliHeaderEnv(this.env)
		this.AuthorToken = Utils.findFromLocalStorage("Author-token");
	},
	async mounted() {
		this.initDate();
		this.$Notice.config( {
			top: 200
		} );
		this.query();
	},
	data() {
		let validatePhone = ( rule, value, callback ) => {
			if ( !value ) {
				callback();
				return;
			}
			if ( value.trim().length == 0 ) {
				callback( new Error( '请输入正确的手机号码' ) );
			} else {
				callback()
			}
		}
		let validateContent = ( rule, value, callback ) => {
			if ( !value ) {
				callback();
				return;
			}
			if ( value.length > 500 ) {
				callback( new Error( '评价内容字数最大为500字' ) );
			} else {
				callback()
			}
		}
		return {
			exportBtn: false,
			title: "短信管理",
			currTabName: "send",
			send: {
				phone: "",
				content: "",
				rules: {
					phone: [
						{required: true, message: "手机号码不能为空", trigger: "blur"},
						{required: true, pattern: phoneRegular, message: "请输入正确的手机号码", trigger: "blur"}
					],
					content: [
						{required: true, message: "短信内容不能为空", trigger: "blur"},
						{max: 500, message: "短信内容字数最大为500字", trigger: "blur"},
					]
				}
			},
			record: {
				columns: [
					{
						title: "发送时间",
						key: "createdAt",
						width: 280,
						render: ( h, params ) => {
							return h(
								"div",
								{},
								Moment.unix( params.row.createdAt / 1000 ).format(
									"YYYY年MM月DD日 HH:mm:ss"
								)
							);
						}
					},
					{
						title: "短信内容",
						align:'center',
						key: "content"
					},
					{
						title: "收件人手机号",
						align:'center',
						key: "phone"
					},
					{
						title: "状态",
						key: "result",
						align:'center',
						render: ( h, params ) => {
							const color = ['','yellow','green','red'][params.row.result]
							const text = ['','发送中','发送成功','发送失败'][params.row.result]
							return h(
								"Tag",
								{
									props: {
										type: "dot",
										color: color
									}
								},
								text
							);
						}
					},
					{
						title: "操作者",
						key: "operator"
					}
				],
				data: [],
				phone: "", //搜索的手机号码
				keyword: "", //搜索的关键字
				page: 1,
				pageSize: 10,
				total: 0,
				date: [],
				rules: {
					phone: [
						{required: false, message: "手机号码不能为空", trigger: "blur"},
						{type: "string", pattern: phoneRegular, message: "请输入正确的手机号码", trigger: "blur"}
					]
				},
				loading: false //表格loading
			},
			appraisal: {
				columns: [
					{
						title: "客户号码",
						key: "phone",
						align: "center",
						width: 200
					},
					{
						title: "号码类型",
						key: "noType",
						align: "center",
						width: 100,
						render: ( h, params ) => {
							let noType = params.row.noType == 1 ? "固话" : "手机"
							return h( "div", {}, noType );
						}
					},
					{
						title: "呼叫类型",
						key: "callType",
						align: "center",
						width: 100,
						render: ( h, params ) => {
							let callType = params.row.callType == 1 ? "呼入" : "呼出"
							return h( "div", {}, callType );
						}
					},
					{
						title: "呼叫时间",
						key: "callDate",
						align: "center",
						width: 120
					},
					{
						title: "座席电话",
						key: "seatNo",
						align: "center",
						width: 200
					},
					{
						title: "通话状态",
						key: "talkType",
						align: "center",
						width: 100,
						render: ( h, params ) => {
							let talkType = params.row.talkType == 1 ? "接听成功" : "接听失败"
							return h( "div", {}, talkType )
						}
					},
					{
						title: "短信发出状态",
						key: "smsType",
						align: "center",
						width: 100,
						render: ( h, params ) => {
							let smsType = params.row.smsType == 1 ? "发送成功" : "发送失败"
							return h( "div", {}, smsType )
						}
					},
					{
						title: "评价状态",
						key: "evaluateType",
						align: "center",
						width: 100,
						render: ( h, params ) => {
							let evaluateType = '';
							switch ( params.row.evaluateType ) {
								case 1:
									evaluateType = "未评价";
									break;
								case 2:
									evaluateType = "已评价";
									break;
								case 3:
									evaluateType = "待评价";
							}
							return h( "div", {}, evaluateType )
						}
					},
					{
						title: "评价时间",
						key: "evaluateDate",
						align: "center",
						width: 120
					},
					{
						title: "评价内容",
						key: "content",
						align: "center",
						width: 280
					}
				],
				data: [],
				date: [],
				talkType: "S00",
				evaluateType: "S00",
				phone: "",
				seatNo: "",
				content: "",
				page: 1,
				pageSize: 10,
				total: 0,
				loading: false, //表格loading
				rules: {
					phone: [
						{validator: validatePhone, trigger: "blur"}
					],
					content: [
						{validator: validateContent, trigger: "blur"},
					]
				}
			},
			omsSmsLoading:false,
			omsRecord: {
				columns: [
					{
						title: "发送时间",
						key: "sendTime",
						align:'center',
						width: 210,
					},
					{
						title: "短信内容",
						key: "content",
						align:'center',
						width: 400,
					},
					{
						title: "收件人手机号",
						key: "phone",
						align:'center',
						width: 140
					},
					{
						title: "订单号",
						key: "orderNo",
						align:'center',
						width: 230,
						render:(h,params) =>{
							let orderNo = params.row.orderNo ? params.row.orderNo : "—"
							return h( "div", {}, orderNo );
						}
					},
					{
						title: "发送通道",
						key: "sendWay",
						align:'center',
						width: 140,
						render: ( h, params ) => {
							const color = ['','yellow','green'][params.row.sendWay]
							const text = ['','阿里','至臻'][params.row.sendWay]
							return h(
								"Tag",
								{
									props: {
										type:"dot",
										color: color
									}
								},
								text
							);
						}
					},
					{
						title: "发送状态",
						key: "sendStatus",
						align:'center',
						width: 150,
						render: ( h, params ) => {
							const color = ['','yellow','green','red'][params.row.sendStatus]
							const text = ['','发送中','发送成功','发送失败'][params.row.sendStatus]
							return h(
								"Tag",
								{
									props: {
										type:"dot",
										color: color
									}
								},
								text
							);
						}
					},
					{
						title:'操作者',
						key:'operator',
						align:'center',
						width: 150
					}
				],
				data: [],
				phone: "", //搜索的手机号码
				keyword: "", //搜索的关键字，
				orderNo:'',//内容，
				sendWay:'S00',//发送通道，
				sendStatus:'S00',//发送状态
				sendBy:'S00',//发送方式
				page: 1,
				pageSize: 10,
				total: 0,
				date: [Moment().subtract( 1, 'day' ).format( "YYYY-MM-DD" ),
				Moment().format( 'YYYY-MM-DD' )
				],
				rules: {
					phone: [
						{required: false, message: "手机号码不能为空", trigger: "blur"},
						{type: "string", pattern: phoneRegular, message: "请输入正确的手机号码", trigger: "blur"}
					]
				},
				loading: false //表格loading
			},
		};
	},
	methods: {
		toggleTab( tabName ) {
			this.currTabName = tabName;
			this[tabName].page = 1;
			this.query();
		},
		async sendSMS() {
			this.$refs["sendForm"].validate( async valid => {
				if ( valid ) {
					const resetSMS = () => {
						( this.send.phone = "" ), ( this.send.content = "" );
					};
					let resp = ( await API.omsAPI[this.env].order.sendSMS(
						this.send.content,
						this.send.phone,
						this.username,
						this.token
					) ).data;

					if ( resp.retCode ) {
						// 失败
						this.$Notice.error( {
							title: "短信发送失败",
							desc: resp.msg
						} );
					} else {
						// 成功
						this.$Notice.success( {
							title: "短信发送成功"
						} );
					}

					resetSMS();
				}
			} );
		},
		initDate() {
			this.record.date = [
				Moment()
					.subtract( 1, "month" )
					.format( "YYYY-MM-DD" ),
				Moment().format( "YYYY-MM-DD" )
			];
			this.appraisal.date = [
				Moment().subtract( 6, "day" ).format( "YYYY-MM-DD" ),
				Moment().format( "YYYY-MM-DD" )
			]
		},
		changePage( pageIndex ) {
			this[this.currTabName].page = pageIndex;
			this.query();
		},
		changePageSize( pageSize ) {
			this[this.currTabName].page = 1;
			this[this.currTabName].pageSize = pageSize;
			this.query();
		},
		selectedDate( date, name ) {
			// debugger
			// console.info(`${date}`)
			this[name].date = date;
		},
		search() {
			this[this.currTabName].page = 1;
			this.query();
		},
		query() {
			if ( this.currTabName == "record" ) {
				this.querySMSRecords();
			} else if ( this.currTabName == "appraisal" ) {
				this.querySMSAppraisals();
			} else if(this.currTabName == "omsRecord"){
				let startDate = this.omsRecord.date[0]
				let endDate = this.omsRecord.date[1]
				let limitDate = 86400000 * 30
				if (endDate - startDate > limitDate) {
					this.$Notice.warning({
						title: "查询失败",
						desc: '查询时间范围最长为30天，请重新选择！'
					});
				}
				this.queryOMSRecords();
			}
		},
		async querySMSRecords() {
			this.record.loading = true;

			let resp = ( await API.omsAPI[this.env].order.querySMSRecords(
				Moment( this.record.date[0] ).format( "YYYY-MM-DD" ),
				Moment( this.record.date[1] ).format( "YYYY-MM-DD" ),
				this.record.keyword,
				this.record.phone,
				this.record.page,
				this.record.pageSize,
				this.token
			) ).data;
			this.record.data = resp.content;
			this.record.total = resp.totalElements;
		},
		async querySMSAppraisals() {
			let isValid = true;
			this.$refs["appraisalForm"].validate( valid => {
				if ( !valid ) {
					isValid = false;
				}
			} );
			if ( !isValid ) {
				return;
			}
			this.appraisal.loading = true;
			let resp = ( await this.sendSMSAppraisals() ).data;

			if ( resp.retCode ) {
				this.$Notice.error( {
					title: "查询失败",
					desc: resp.msg
				} );
			}

			this.appraisal.data = resp.result;
			this.appraisal.total = resp.count;
			this.appraisal.loading = false;
		},
		// 【OMS】短信记录
		async queryOMSRecords(){
			if ( !Utils.hasPermission( 'api_sms_smsRecordList' ) ) {
				this.$Notice.error( {
					title: "无权限操作"
				} );
				return
			}
			let params = {
				pageNum:this.omsRecord.page,
				pageSize:this.omsRecord.pageSize,
			}
			this.omsRecord.date[0] !== '' && (params.sendTimeBegin = Moment(this.omsRecord.date[0]).format('YYYY-MM-DD'))
			this.omsRecord.date[1] !== '' && (params.sendTimeEnd = Moment(this.omsRecord.date[1]).format('YYYY-MM-DD'))
			this.omsRecord.phone !== '' && (params.phone = this.omsRecord.phone)
			this.omsRecord.keyword !== '' && (params.content = this.omsRecord.keyword)
			this.omsRecord.orderNo !== '' && (params.orderNo = this.omsRecord.orderNo)
			this.omsRecord.sendWay !== 'S00' && (params.sendWay = this.omsRecord.sendWay)
			this.omsRecord.sendStatus !== 'S00' && (params.sendStatus = this.omsRecord.sendStatus)
			this.omsRecord.sendBy !== 'S00' && (params.sendBy = this.omsRecord.sendBy)
			this.omsSmsLoading = true
			const resp = (await API.omsAPI[this.env].clientServer.smsRecordList(params, {'x-ca-stage':this.headerENV,'Authorization':this.AuthorToken})).data;
			this.omsSmsLoading = false
			if ( resp.retCode ) {
				this.$Notice.error( {
					title: "查询失败",
					desc: resp.msg
				} );
			}
			this.omsRecord.data = resp.list
			this.omsRecord.total = resp.total
		},
		sendSMSAppraisals() {
			let params = {
				callDateBegin: Moment( this.appraisal.date[0] ).format( "YYYY-MM-DD" ),
				callDateEnd: Moment( this.appraisal.date[1] ).format( "YYYY-MM-DD" ),
				pageSize: this.appraisal.pageSize,
				startRow: this.appraisal.page
			}
			this.appraisal.talkType !== "S00" ? params.talkType = this.appraisal.talkType : "";
			this.appraisal.evaluateType !== "S00" ? params.evaluateType = this.appraisal.evaluateType : "";
			this.appraisal.phone ? params.phone = this.appraisal.phone : "";
			this.appraisal.seatNo ? params.seatNo = this.appraisal.seatNo : "";
			this.appraisal.content ? params.content = this.appraisal.content : "";

			return API.omsAPI[this.env].order.queryEvaluateList( params, this.token );
		},
		exportAppraisal() {
			if ( !this.checkHasPermission( 'excel_exportEvaluate' ) ) {
				return;
			}

			let url = `${ Config[this.env].analysisUrl }excel/exportEvaluate?startRow=1&pageSize=999999` +
				"&callDateBegin=" + ( Moment( this.appraisal.date[0] ).format( "YYYY-MM-DD" ) ) +
				"&callDateEnd=" + ( Moment( this.appraisal.date[1] ).format( "YYYY-MM-DD" ) ) +
				"&talkType=" + ( this.appraisal.talkType !== "S00" ? this.appraisal.talkType : "" ) +
				"&evaluateType=" + ( this.appraisal.evaluateType !== "S00" ? this.appraisal.evaluateType : "" ) +
				"&phone=" + this.appraisal.phone +
				"&seatNo=" + this.appraisal.seatNo +
				"&content=" + this.appraisal.content;

			// window.open(url ,"_blank");
			Utils.exportExcelWeighting( url, this.token, this.$Notice.error, this, "exportBtn")

		},
		checkHasPermission( name ) {
			if ( !Utils.hasPermission( name ) ) {
				this.$Notice.error( {
					title: Utils.getFromStore( STORE_KEY.STORE_KEY_NOT_PERMISSION_TIPS )
				} );

				return false;
			}
			return true;
		},
		preventSubmit(){
			return false;
		}
	}
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/order/sms.vue